'use client';
import { useEffect, useState } from 'react';

const formatTimeLeftUnits = (value: number) => (value > 9 ? value : `0${value}`);

interface Props {
    days?: number;
    hours?: number;
    minutes?: number;
    seconds?: number;
}

export const CountDownTimer = ({ days = 0, hours = 0, minutes = 0, seconds = 0 }: Props) => {
    const [remainingHours, setRemainingHours] = useState(0);
    const [remainingMinutes, setRemainingMinutes] = useState(0);
    const [remainingSeconds, setRemainingSeconds] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (remainingSeconds > 0) {
                setRemainingSeconds(remainingSeconds - 1);
                return;
            }

            if (remainingMinutes > 0) {
                setRemainingMinutes(remainingMinutes - 1);
                setRemainingSeconds(59);
                return;
            }

            if (remainingHours === 0) {
                clearInterval(intervalId);
            } else {
                setRemainingHours(remainingHours - 1);
                setRemainingMinutes(59);
                setRemainingSeconds(59);
            }
        }, 1000);

        return () => {
            clearInterval(intervalId);
        };
    });

    useEffect(() => {
        if (days > 0) {
            setRemainingHours(days * 24 + hours);
        } else {
            setRemainingHours(hours || 0);
        }
        setRemainingMinutes(minutes || 0);
        setRemainingSeconds(seconds || 0);
    }, [days, hours, minutes, seconds]);

    if (remainingHours === 0 && remainingMinutes === 0 && remainingSeconds === 0) {
        return null;
    }

    const remainingHoursText = remainingHours > 0 ? `${remainingHours}h ` : '';
    const remainingMinutesText = `${formatTimeLeftUnits(remainingMinutes)}m `;
    const remainingSecondsText = `${formatTimeLeftUnits(remainingSeconds)}s`;

    return <span> {`${remainingHoursText}${remainingMinutesText}${remainingSecondsText}`} </span>;
};
